import React from "react"

import { useNavigate } from "react-router-dom"

import { ButtonElement } from "@front-shared/elements/button.element.tsx"
import { FixedTopRightActionElement } from "@front-shared/elements/fixedTopRightAction.element.tsx"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { GENERAL_CONFIG } from "../../config/general.config"
import { LogoutHelper } from "../../helpers/logout.helper.ts"
import { useAppDispatch } from "../../store/appDispatch.hook.ts"

import logo from "@front-shared/assets/images/logo-small.svg"
import mainImage from "@front-shared/assets/images/shapes/locked.svg"

export const PracticeRoleMissingLockComponent: React.FunctionComponent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    return (
        <div className="fixed z-1070 let-0 top-0 bg-brand-offWhite w-screen h-screen pt-[40px] px-[40px]">
            <div className="pb-[42px]">
                <img src={logo} alt="Nirvana" />
            </div>

            <img
                src={mainImage}
                alt="Nirvana"
                title="Nirvana"
                className="margin-x-center sm:w-[150px]"
            />

            <PrimaryText className="mt-[44px]" typography="h4" centered>
                You’ll need to be part of an organization to proceed.
            </PrimaryText>

            <PrimaryText className="mt-[32px]" typography="subtitle" centered>
                Please accept an organizational invite, <br />
                or reach out to create an organization yourself.
            </PrimaryText>

            <div className="text-center mt-[32px]">
                <a href={`mailto:${GENERAL_CONFIG.supportEmail}`}>
                    <ButtonElement
                        label="Contact us"
                        type="primary"
                        htmlType="button"
                        size="large"
                    />
                </a>
            </div>

            {/*Logout*/}
            <FixedTopRightActionElement
                ctaLabel="Log out"
                ctaAction={() => {
                    LogoutHelper.logout(dispatch, undefined, navigate)
                }}
            />
        </div>
    )
}
